// 담당(claim) 매칭 — 동 단위와 학교 단위를 모두 지원.
import type { DongClaim, Student } from "@/types";
import { normalizeSchool } from "@/lib/school";

/** 이 담당이 해당 학생을 포함하는가. scope 없으면 동 단위(하위호환). */
export function claimMatchesStudent(
  c: Pick<DongClaim, "scope" | "gu" | "dong" | "school">,
  s: Pick<Student, "gu" | "dong" | "school">,
): boolean {
  // 학교명 표기 차이("개림중"↔"개림중학교")를 무시하고 매칭
  if (c.scope === "school") return !!c.school && normalizeSchool(c.school) === normalizeSchool(s.school);
  return c.gu === s.gu && c.dong === s.dong;
}

/** 담당 1건의 고유 키 (드래프트/중복 비교용). */
export function claimKey(c: Pick<DongClaim, "scope" | "gu" | "dong" | "school">): string {
  return c.scope === "school" ? `S::${normalizeSchool(c.school)}` : `${c.gu}|${c.dong}`;
}

/**
 * 이번 달 아무 기사도 안 맡은 직배송 학생(대표 결정 Q23) — 기사 경로에 안 나와 경고 없이 배송에서 빠지는 집.
 * 직배송 = 상태가 배송 대상이고(src/lib/deliveryGuard.ts와 같은 판정) 택배가 아님.
 */
export function unclaimedStudents<S extends Pick<Student, "gu" | "dong" | "school" | "status" | "courierFlag">>(
  students: S[],
  claims: Pick<DongClaim, "scope" | "gu" | "dong" | "school">[],
): S[] {
  return students.filter(
    (s) => (!s.status || s.status === "active") && !s.courierFlag && !claims.some((c) => claimMatchesStudent(c, s)),
  );
}

/** 담당 1건의 사람용 라벨. */
export function claimLabel(c: Pick<DongClaim, "scope" | "gu" | "dong" | "school">): string {
  return c.scope === "school" ? `🎒 ${c.school}` : `${c.gu} ${c.dong}`;
}
